"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_popper_1 = require("react-popper");
var Icons_1 = require("../../_Core/Icons");
var Keyboard_1 = require("../../_Core/Keyboard");
var Icon_1 = require("../../Icons/Icon/Icon");
var Lists_1 = require("../../Lists");
var ReactPortalWrapper_1 = require("../../ReactPortalWrapper");
var Theme_1 = require("../../Theme");
var ButtonDropList_styles_1 = require("./ButtonDropList.styles");
var ButtonDropList = /** @class */ (function (_super) {
    __extends(ButtonDropList, _super);
    function ButtonDropList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { ShowDropdown: false, IsHovered: false };
        _this.IconProps = { Height: "24px", Width: "24px" };
        _this.handleKeyBoardEvents = function (e) {
            e.stopPropagation();
            if (Keyboard_1.IsDownArrow(e)) {
                _this.setState({ ShowDropdown: true });
            }
        };
        return _this;
    }
    ButtonDropList.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_popper_1.Manager, null,
            React.createElement(react_popper_1.Reference, null, function (_a) {
                var ref = _a.ref;
                return (React.createElement(ButtonDropList_styles_1.Button, { "aria-label": _this.props.AriaLabel, "aria-haspopup": true, "aria-expanded": _this.state.ShowDropdown, ref: function (e) {
                        if (typeof ref === "function") {
                            ref(e);
                        }
                        _this.button = e;
                    }, type: "button", Variation: _this.props.Variation, style: _this.props.EndButton ? { borderRadius: "0 5px 5px 0" } : {}, disabled: _this.props.Disabled, onKeyUp: _this.handleKeyBoardEvents, onClick: function () { return _this.setState({ ShowDropdown: !_this.state.ShowDropdown }); }, onMouseEnter: function () { return _this.setState({ IsHovered: true }); }, onMouseLeave: function () { return _this.setState({ IsHovered: false }); } },
                    _this.props.Icon && _this.props.ShowIcon && (React.createElement(ButtonDropList_styles_1.IconContainer, null,
                        React.createElement(Icon_1.Icon, __assign({ Icon: _this.props.Icon }, _this.IconProps)))),
                    _this.props.Caption && React.createElement(ButtonDropList_styles_1.Caption, null, _this.props.Caption),
                    _this.props.ShowArrow && (React.createElement(ButtonDropList_styles_1.DropIcon, { Variation: _this.props.Variation, ShowDropdown: _this.state.ShowDropdown, ButtonHover: _this.state.IsHovered }, _this.props.Direction === "Down" ? (React.createElement(Icon_1.Icon, __assign({ Icon: Icons_1.Icons.CaretDown }, _this.IconProps))) : (React.createElement(Icon_1.Icon, __assign({ Icon: Icons_1.Icons.CaretUp }, _this.IconProps)))))));
            }),
            !this.props.Disabled && this.state.ShowDropdown && (React.createElement(ReactPortalWrapper_1.Modal, { DisableAutoFocus: true },
                React.createElement(react_popper_1.Popper, { placement: this.props.Placement ? this.props.Placement : this.props.Direction === "Down" ? "bottom-start" : "top-start" }, function (_a) {
                    var ref = _a.ref, style = _a.style, placement = _a.placement;
                    return (React.createElement(Lists_1.DropList, { ref: ref, Style: __assign(__assign({}, style), { zIndex: Theme_1.portalsZIndex }), Placement: placement, OnCloseMenu: function () {
                            return _this.setState({ ShowDropdown: false }, function () { return _this.button.focus(); });
                        } }, _this.props.children));
                })))));
    };
    ButtonDropList.defaultProps = { ShowArrow: true, ShowIcon: true, Direction: "Down" };
    return ButtonDropList;
}(React.PureComponent));
exports.default = ButtonDropList;
